/**
 * tattooDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, type ToilePack} from './data'

export const tattooDesignsPack: ToilePack = {
    slug: 'tattoo-designs',
    category: 'tattoo',
    name: 'Tattoo designs',
    tagline: 'Nine designs, three readings, three styles each.',
    chips: ['9 designs', '3 readings × 3 styles', 'sample only'],
    ratio: PORTRAIT,
    readings: [
        {key: 'koi', label: 'Koi', subject: 'a koi fish leaping through water, lotus and waves'},
        {key: 'wolf', label: 'Wolf', subject: 'a wolf head in profile howling, pine and moon'},
        {key: 'dagger', label: 'Dagger', subject: 'a dagger through a rose, a ribbon banner'},
    ],
    styles: [
        {key: 'fineline', label: 'Fineline', style: 'fine-line blackwork, single-needle', palette: 'black ink on white', framing: 'forearm placement, flat sheet'},
        {key: 'trad', label: 'Traditional', style: 'American traditional flash', palette: 'bold 4-ink flash', framing: 'forearm placement, flat sheet'},
        {key: 'geometric', label: 'Geometric', style: 'geometric dotwork, sacred-geometry framing', palette: 'black ink, dot gradients', framing: 'forearm placement, flat sheet'},
    ],
    directions: ['a snake instead', 'with red ink added', 'heavier black shading'],
}
